import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormFields, Stack, FormTextField, FormActions } from "sprint-common-web";

import { EditTvSeriesInfoFormInputs } from "./EditTvSeriesInfoFormInputs";
import { useEditTvSeriesInfoForm } from "./useEditTvSeriesInfoForm";

export interface EditTvSeriesInfoFormProps {
    onCancel(): void;
    onSubmit(updatedTvSeriesData: UpdatedTvSeriesData): void;
}

export interface UpdatedTvSeriesData {
    title: string;
}

export const EditTvSeriesInfoForm: React.FunctionComponent<EditTvSeriesInfoFormProps> = (
    props: EditTvSeriesInfoFormProps
) => {
    const { defaultInputs, updateTvSeries, validateTitle } = useEditTvSeriesInfoForm();

    const { errors, control, formState, handleSubmit } = useForm<EditTvSeriesInfoFormInputs>({
        defaultValues: defaultInputs,
        criteriaMode: "all"
    });

    const clearAndCallOnClose = () => {
        props.onCancel();
    };

    const editTvSeries = async (inputs: EditTvSeriesInfoFormInputs) => {
        const updatedTvSeries = await updateTvSeries(inputs);

        props.onSubmit(updatedTvSeries);
    };

    return (
        <>
            <Form onSubmit={handleSubmit(editTvSeries)}>
                <FormFields>
                    <Stack>
                        <FormTextField
                            label="Title"
                            name="title"
                            control={control}
                            errors={errors}
                            rules={{ required: "Please enter Tv Series Title", validate: validateTitle }}
                        />
                    </Stack>
                </FormFields>
                <FormActions
                    isLoading={formState.isSubmitting || formState.isValidating}
                    onCancel={clearAndCallOnClose}
                />
            </Form>
        </>
    );
};
